module.exports = __webpack_public_path__ + "dimer/static/img/6.66ad9d3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/globalPartner/6.jpg
// module id = KtLg
// module chunks = 0